<template>
  <v-progress-linear
    :active="$bar.isActive"
    :color="$bar.color"
    :indeterminate="true"
    :height="$bar.height"
  />
</template>

<script setup>
defineOptions({ name: "ToolbarLoadingComponent" });
</script>
